import {
  ToggleIconButton,
  ToggleButtonGroup,
} from "@tokenterminal/core/ui/input/toggle/ToggleButtonGroup"
import {
  themeOptions,
  useThemeContext,
  type ThemePreference,
} from "@tokenterminal/ui/Theme/ThemeContext"

const ThemeSwitcherToggle = () => {
  const { preferredTheme, setPreferredTheme } = useThemeContext()

  return (
    <ToggleButtonGroup
      selectedKey={preferredTheme}
      onSelectionChange={(key) => setPreferredTheme(key as ThemePreference)}
      size="small"
    >
      {Object.entries(themeOptions).map((entry) => {
        const [theme, { icon, label }] = entry as unknown as [
          ThemePreference,
          (typeof themeOptions)[keyof typeof themeOptions],
        ]
        return (
          <ToggleIconButton
            key={theme}
            id={theme}
            icon={icon}
            data-tooltip={label}
          />
        )
      })}
    </ToggleButtonGroup>
  )
}

export default ThemeSwitcherToggle
